import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import http from 'axios'
import { Button, Checkbox, FormControl, FormControlLabel, Grid, Icon, NativeSelect, useMediaQuery } from '@mui/material'
import { useTheme, withStyles } from '@mui/styles'
import { style } from 'styles'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import { PayPalBanner, QuantitySelector } from 'components'
import { calculatePriceWithOptions, formatNumber, saveAccess } from 'core/lib'

function ProductDetails({ classes }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const theme = useTheme()
	const { productParam } = useParams()
	const { product } = useSelector(state => state.products)
	const [finalPrice, setFinalPrice] = useState(0)
	const [invalidOptions, setInvalidOptions] = useState([])
	const [selectedOptions, setSelectedOptions] = useState({})
	const [quantity, setQuantity] = useState(1)
	const shop = useSelector(state => state.shop)
	const isCatalogue = Number(shop.profiles.ueby_catalogue_only)
	const showImagesNav = useMediaQuery(theme.breakpoints.up('sm'))
	const showImagesBullets = useMediaQuery(theme.breakpoints.down('xs'))

	useEffect(() => {
		const loadProduct = async() => {
			const productId = productParam.split('-').pop()
			const product = await http.get(`${window.__endpoint}/api/product/${productId}`)
			dispatch({ type: 'loadProduct@products', product: product })
			setFinalPrice(product.price)

			// Salvo l'accesso
			saveAccess('product', productId)
		}

		loadProduct()
	}, [productParam])

	useEffect(() => {
		//* se modifico le opzioni o la quantità ricalcolo il prezzo
		const recalcPrice = () => {
			if (product) {
				const cartProduct = configureProduct()
				setFinalPrice(cartProduct.price * quantity)
			}
		}

		recalcPrice()
	}, [selectedOptions, quantity])

	const changeSelectedOptionSingle = (e) => {
		let value = ''
		if (e.target.type == 'checkbox') {
			value = e.target.checked
		} else {
			value = e.target.value
		}
		setSelectedOptions({
			...selectedOptions,
			[e.target.name]: value
		})
	}
	const changeSelectedOptionMultiple = (e, value) => {
		let newValue = selectedOptions[e.target.name] || []
		if (e.target.checked) {
			newValue.push(value)
		} else {
			newValue.splice(newValue.indexOf(value), 1)
		}
		setSelectedOptions({
			...selectedOptions,
			[e.target.name]: newValue
		})
	}

	const addToCart = () => {
		const cartProduct = configureProduct()
		// Verifico se siano selezionate le eventuali opzioni obbligatorie
		const missingOptions = product.options.map(option => {
			if (Number(option.required_flag) == 1) {
				if (option.category_option_id > 0) {
					if (cartProduct.options.map(o => o.category_option_id).includes(option.category_option_id)
						&& cartProduct.options.find(o => o.category_option_id == option.category_option_id).values.length > 0) {
						return null
					} else {
						return `c_${option.category_option_id}`
					}
				} else {
					if (cartProduct.options.map(o => o.item_option_id).includes(option.item_option_id)
						&& cartProduct.options.find(o => o.item_option_id == option.item_option_id).values.length > 0) {
						return null
					} else {
						return `i_${option.item_option_id}`
					}
				}
			} else {
				return null
			}
		}).filter(v => !!v)
		setInvalidOptions(missingOptions)
		if (missingOptions.length > 0) {
			dispatch({ type: 'setFeedback@ui', message: 'Opzioni obbligatorie non selezionate', color: 'error', hideDuration: 5000 })
		} else {
			dispatch({ type: 'addProduct@cart', product: cartProduct, quantity: quantity, availableQuantity: shop.profiles.ueby_item_quantity_check == 1 ? product.quantity : null })
			dispatch({ type: 'setFeedback@ui', message: 'Prodotto aggiunto al carrello' })
		}
	}

	const configureProduct = () => {
		let cartOptions = []
		let cartKey = product.item_id
		Object.keys(selectedOptions).forEach(option => {
			let cartOption = { ...product.options.filter(o => o.option_id == option)[0] }
			cartKey = cartKey + '|' + option + ':'
			cartOption['values'] = cartOption.values.filter(v => selectedOptions[option].includes(v.option_value_id))
			cartKey = cartKey + cartOption['values'].map(v => v.option_value_id).join('-')
			cartOptions.push(cartOption)
		})
		const finalPrice = calculatePriceWithOptions({
			...product,
			options: cartOptions
		})
		return {
			...product,
			key: cartKey,
			options: cartOptions,
			price: finalPrice,
		}
	}

	return (<div className={classes.page}>
		{product && <Grid container spacing={3} className={classes.productDetails}>
			<Grid item xs={12} sm={5} md={6} lg={4} className="gallery">
				<ImageGallery
					items={[
						{
							original: `${window.__endpoint}/images/products/l/${product.main_image ? product.main_image.image_id : 'missing'}.jpg`,
							thumbnail: '',
						},
						...product.images.map(image => {
							return {
								original: `${window.__endpoint}/images/products/l/${image.image_id}.jpg`,
								thumbnail: '',
							}
						})
					]}
					showBullets={showImagesBullets}
					showFullscreenButton={false}
					showNav={showImagesNav}
					showPlayButton={false}
					showThumbnails={false}
				/>
			</Grid>
			<Grid item xs={12} sm={7} md={6} lg={8}>
				{product.html_title && product.html_title != '' && <h2 className={classes.pageTitle} dangerouslySetInnerHTML={{
					__html: product.html_title
				}}></h2>}
				{product.html_description && product.html_description != '' && <div dangerouslySetInnerHTML={{
					__html: product.html_description
				}}></div>}
				<div className="itemPrice">
					{product.offer_active && <del>{formatNumber(product.item_price)} €</del>}
					{formatNumber(product.price)} €
				</div>

				{!isCatalogue && <React.Fragment>
					{product.options.length > 0 && <Grid container spacing={3} className="options">
						{product.options.map((option, o) => (<Grid item xs={12} key={o}>
							<Grid container spacing={0}>
								<Grid item xs={12} sm={12} md={3}>
									<span className="label">
										{option.name}{Number(option.required_flag) == 1 && ' *'}
									</span>
									{(invalidOptions.includes(`i_${option.item_option_id}`) || invalidOptions.includes(`c_${option.category_option_id}`)) && <div className={classes.error}><small>Opzione obbligatoria</small></div>}
								</Grid>
								<Grid item xs={12} sm={12} md={9} style={{ paddingTop: 6 }}>
									{option.multiple_values_flag == 1 && <React.Fragment>
										{option.values.map((value, v) => (<div key={v}>
											<FormControlLabel
												control={
													<Checkbox
														onChange={(e) => { changeSelectedOptionMultiple(e, value.option_value_id) }}
														name={String(option.option_id)}
														color="primary"
														checked={selectedOptions[option.option_id] ? selectedOptions[option.option_id].includes(value.option_value_id) : false}
													/>
												}
												label={value.value}
											/>
											{value.price_variation && value.price_variation != 0 && <small>({formatNumber(value.price_variation)} €)</small>}
										</div>))}
									</React.Fragment>}
									{option.multiple_values_flag == 0 && <FormControl>
										<NativeSelect
											fullWidth
											value={selectedOptions[option.option_id] || ''}
											onChange={changeSelectedOptionSingle}
											name={String(option.option_id)}
										>
											<option value="">Seleziona un opzione</option>
											{option.values.map((value, v) => <option key={v} value={value.option_value_id}>
												{value.value}
												{value.price_variation && value.price_variation != 0 && ` (${formatNumber(value.price_variation)} €)`}
											</option>)}
										</NativeSelect>
									</FormControl>}
								</Grid>
							</Grid>
						</Grid>))}
					</Grid>}

					<Grid container spacing={1} className="quantity">
						<Grid item xs={12}>
							<div className="finalPrice">
								<span className="label">Totale:</span> {formatNumber(finalPrice)} €
							</div>
						</Grid>
						{shop.paypal_banner_flag == 1 && shop.paypal_id != '' && <Grid item xs={12}>
							<div style={{ paddingLeft: 10 }}>
								<PayPalBanner
									clientId={shop.paypal_id}
									amount={finalPrice}
								/>
							</div>
						</Grid>}
						{shop.profiles.ueby_item_quantity_check == 1 && <Grid item xs={12}>
							<div className="availability">
								<span className="label">Disponibilità:</span> {product.quantity}
							</div>
						</Grid>}
						<Grid item xs={2}>
							<span className="label">Qtà</span>
						</Grid>
						<Grid item xs={6}>
							<QuantitySelector
								quantity={quantity}
								setQuantity={setQuantity}
								availableQuantity={shop.profiles.ueby_item_quantity_check == 1 ? product.quantity : null}
							/>
						</Grid>
						<Grid item xs={4}>
							<Button color="primary" variant="contained" className="addButton" onClick={addToCart}><Icon>add_shopping_cart</Icon></Button>
						</Grid>
					</Grid>
				</React.Fragment>}
			</Grid>
		</Grid>}
	</div>)
}

export default withStyles(style)(ProductDetails)
